(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/scroll-slider
 * -----------------------------------------------------------------------------
 * @version 0.0.9
 * @overview Scroll slider progressive enhancements.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("scroll-slider") === undefined) {
    class ScrollSlider extends HTMLElement {
        constructor(){
            super();
            this.slider = this.querySelector(".scroll-slider");
            if (!this.slider) return;
            this.slides = Array.from(this.slider.children);
            this.scrollObserver();
            this.resizeObserver();
            this.newSlideObserver();
        }
        scrollToItem(item) {
            if (!this.slides[item]) return;
            this.slider.scroll({
                left: this.slides[item].offsetLeft
            });
        }
        returnVisibleSlides() {
            return this.slides.filter((slide)=>Math.round(slide.getBoundingClientRect().left) >= Math.round(this.slider.getBoundingClientRect().left) && Math.round(slide.getBoundingClientRect().right) <= Math.round(this.getBoundingClientRect().right));
        }
        scrollObserver() {
            let scrollTimer;
            this.scrolling = false;
            this.slider.addEventListener("scroll", (event)=>{
                window.clearTimeout(scrollTimer);
                if (!this.scrolling) {
                    this.scrolling = true;
                    this.setAttribute("data-scrolling", "");
                    this.dispatchEvent(new CustomEvent("scroll:started"));
                }
                scrollTimer = setTimeout(()=>{
                    this.scrolling = false;
                    this.removeAttribute("data-scrolling");
                    this.dispatchEvent(new CustomEvent("scroll:finished"));
                }, 100);
            }, false);
        }
        resizeObserver() {
            new ResizeObserver(()=>this.scrollToItem(this.returnVisibleSlides()[0])).observe(this.slider);
        }
        newSlideObserver() {
            new MutationObserver((event)=>{
                if (event.map((item)=>item.target === this.slider)) this.slides = Array.from(this.slider.children);
            }).observe(this.slider, {
                childList: true
            });
        }
    }
    customElements.define("scroll-slider", ScrollSlider);
}


/*
 * -----------------------------------------------------------------------------
 * @cam/scroll-slider-cursor
 * -----------------------------------------------------------------------------
 * @version 0.0.7
 * @overview Arrow navigation for scroll-slider progressive enhancements.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
 * @requires component:scroll-slider
 * -----------------------------------------------------------------------------
*/ if (customElements.get("scroll-slider-cursor") === undefined) {
    class ScrollSliderCursor extends HTMLElement {
        constructor(){
            super();
            this.slider = this.closest("scroll-slider");
            if (!this.slider) return;
            this.nextButton = this.querySelector('[name="next"]');
            this.previousButton = this.querySelector('[name="previous"]');
            if (this.nextButton) this.nextButton.addEventListener("click", this.debounce(this.nextSlide.bind(this), 100));
            if (this.previousButton) this.previousButton.addEventListener("click", this.debounce(this.previousSlide.bind(this), 100));
            if (this.nextButton || this.previousButton) this.navigationVisibility();
            this.resizeObserve = new ResizeObserver((entries)=>this.navigationVisibility()).observe(this.slider);
            this.slider.addEventListener("scroll:started", this.disableInteraction.bind(this));
            this.slider.addEventListener("scroll:finished", this.enableInteraction.bind(this));
        }
        debounce(callback, timeout) {
            let timer;
            return (...args)=>{
                clearTimeout(timer);
                timer = setTimeout(()=>callback.apply(this, args), timeout);
            };
        }
        nextSlide() {
            this.slider.scrollToItem(this.slider.returnVisibleSlides().at(-1) === this.slider.slides[this.slider.slides.length - 1] ? 0 : this.slider.slides.indexOf(this.slider.returnVisibleSlides()[0]) + 1);
        }
        previousSlide() {
            this.slider.scrollToItem(this.slider.returnVisibleSlides()[0] === this.slider.slides[0] ? this.slider.slides.length - 1 : this.slider.slides.indexOf(this.slider.returnVisibleSlides()[0]) - 1);
        }
        navigationVisibility() {
            this.hidden = this.slider.returnVisibleSlides().length === this.slider.slides.length;
        }
        disableInteraction() {
            if (this.nextButton) this.nextButton.disabled = true;
            if (this.previousButton) this.previousButton.disabled = true;
            this.timeOut = setTimeout(()=>this.enableInteraction(), 1000);
        }
        enableInteraction() {
            if (this.nextButton) this.nextButton.disabled = false;
            if (this.previousButton) this.previousButton.disabled = false;
            clearTimeout(this.timeOut);
        }
    }
    customElements.define("scroll-slider-cursor", ScrollSliderCursor);
}


/*
 * -----------------------------------------------------------------------------
 * @cam/scroll-slider-thumbs
 * -----------------------------------------------------------------------------
 * @version 0.0.8
 * @overview Thunbnail navigation for scroll-slider progressive enhancements.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
 * @requires @cam/scroll-slider
 * -----------------------------------------------------------------------------
*/ if (customElements.get("scroll-slider-thumbs") === undefined) {
    class ScrollSliderThumbs extends HTMLElement {
        constructor(){
            super();
            this.slider = this.closest("scroll-slider");
            if (!this.slider) return;
            this.thumbs = this.querySelectorAll("button");
            if (!this.thumbs) return;
            this.thumbs.forEach((item)=>item.addEventListener("click", this.clickEvents.bind(this), false));
            this.slider.addEventListener("scroll:finished", this.scrollFinished.bind(this));
        }
        clickEvents(item) {
            this.thumbs.forEach((thumb)=>thumb.setAttribute("aria-pressed", false));
            item.target.setAttribute("aria-pressed", true);
            this.slider.scrollToItem(Array.from(this.thumbs).findIndex((element)=>element === item.target));
        }
        scrollFinished() {
            this.thumbs.forEach((thumb)=>thumb.setAttribute("aria-pressed", false));
            this.slider.returnVisibleSlides().forEach((item)=>this.thumbs[this.slider.slides.indexOf(item)].setAttribute("aria-pressed", true));
        }
    }
    customElements.define("scroll-slider-thumbs", ScrollSliderThumbs);
}



})();
